module.exports = __webpack_public_path__ + "eabc9e847efc2060ee169924b3865861.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_mailbox.png
// module id = 87
// module chunks = 0 1 2 3 4